export const START_CHAT_REQUEST = 'START_CHAT_REQUEST';
export const START_CHAT_SUCCESS = 'START_CHAT_SUCCESS';
export const START_CHAT_ERROR = 'START_CHAT_ERROR';
export const SEND_TEXT_MESSAGE_REQUEST = 'SEND_TEXT_MESSAGE_REQUEST';
export const SEND_TEXT_MESSAGE_SUCCESS = 'SEND_TEXT_MESSAGE_SUCCESS';
export const SEND_TEXT_MESSAGE_ERROR = 'SEND_TEXT_MESSAGE_ERROR';
export const SEND_TYPING_REQUEST = 'SEND_TYPING_REQUEST';
export const SEND_TYPING_SUCCESS = 'SEND_TYPING_SUCCESS';
export const SEND_TYPING_ERROR = 'SEND_TYPING_ERROR';
export const SAVE_USER_RESPONSE = 'SAVE_USER_RESPONSE';
export const SAVE_BOT_RESPONSE = 'SAVE_BOT_RESPONSE';
export const SAVE_BOT_TYPING_ON = 'SAVE_BOT_TYPING_ON';
export const SAVE_BOT_TYPING_OFF = 'SAVE_BOT_TYPING_OFF';
export const STOP_CHAT = 'STOP_CHAT';
export const OPEN_CHAT_BOX = 'OPEN_CHAT_BOX';
export const TOGGLE_MINIMIZE_CHAT_BOX = 'TOGGLE_MINIMIZE_CHAT_BOX';
export const CLOSE_CHAT_BOX = 'CLOSE_CHAT_BOX';
export const RESTART_CHAT_REQUEST = 'RESTART_CHAT_REQUEST';
export const RESTART_CHAT_SUCCESS = 'RESTART_CHAT_SUCCESS';
export const UPDATE_DIALOG_ID = 'UPDATE_DIALOG_ID';
export const SET_DIALOG_META = 'SET_DIALOG_META';
export const SET_SESSION_CHAT_DATA = 'SET_SESSION_CHAT_DATA';
export const START_RETRY_CONNECT = 'START_RETRY_CONNECT';
export const STOP_RETRY_CONNECT = 'STOP_RETRY_CONNECT';
export const SET_DIALOG_ENDED = 'SET_DIALOG_ENDED';
export const SET_DISABLE_CHAT = 'SET_DISABLE_CHAT';
export const SET_ACTIVE_API_URL = 'SET_ACTIVE_API_URL';
export const SET_FAILED_API_URL = 'SET_FAILED_URL';
export const CLEAR_FAILED_API_URLS = 'CLEAR_FAILED_API_URLS';
export const SET_CHAT_WITH_AGENT = 'SET_CHAT_WITH_AGENT';
export const SET_FEEDBACK_FORM = 'SET_FEEDBACK_FORM';
export const UPDATE_THREAD_MESSAGE = 'UPDATE_THREAD_MESSAGE';
export const DELETE_THREAD_MESSAGE = 'DELETE_THREAD_MESSAGE';
export const SET_ATTACHMENTS_CONFIG = 'SET_ATTACHMENTS_CONFIG';
export const SET_MESSAGE_ERROR = 'SET_MESSAGE_ERROR';
export const SET_DEBUG_INFO = 'SET_DEBUG_INFO';
export const SAVE_META_MESSAGE = 'SAVE_META_MESSAGE';
export const SET_IS_HISTORY = 'SET_IS_HISTORY';
export const SET_SESSION_EXPIRED = 'SET_SESSION_EXPIRED';
export const SET_AGENT_CONNECTING = 'SET_AGENT_CONNECTING';
export const SET_AGENT_CONNECTED = 'SET_AGENT_CONNECTED';
export const SET_AGENT_TIMEOUT = 'SET_AGENT_TIMEOUT';
export const SET_SENSITIVE_INPUT = 'SET_SENSITIVE_INPUT';
